import React from "react";
import {
  Box,
  Button,
  Modal,
  CircularProgress,
  Typography,
} from "@mui/material";

const style = {
  bgcolor: "background.paper",
  boxShadow: 24,
};

export const MatchmakingLoader = ({
  isOpen,
  close,
  failed,
}: {
  isOpen: boolean;
  close: () => void;
  failed: boolean;
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={() => {}}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div
        className="contain-sm"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Box
          sx={style}
          className="d-flex flex-column justify-content-center align-items-center p-5"
        >
          {failed ? (
            <Typography>No player online right now</Typography>
          ) : (
            <>
              <Typography>Looking for opponent</Typography>
              <CircularProgress />
            </>
          )}

          <Button
            className="mt-4"
            onClick={() => {
              close();
            }}
            variant="contained"
            size="large"
          >
            Cancel
          </Button>
        </Box>
      </div>
    </Modal>
  );
};
